import '../App.css';
import Footer from './Footer';
import ProgressCheckout from './ProgressCheckout';
import TableCheckout from './TableCheckout';
import { useState, useEffect } from "react";
import ReactWhatsapp from 'react-whatsapp';
import Header from './Header';
import Swal from 'sweetalert2';


function VerificacionCheckout() {

    let p1 = 3;

    const [entregaPago, setEntregaPago] = useState(0);
    const [tipoEntrega, setTipoEntrega] = useState('');
    const [direccion, setDireccion] = useState([]);

    const redireccionarAtras=()=>{
        window.location.href = '/midireccion'
    }

    const redireccionarSiguiente=()=>{
        if(entregaPago===0){
            Swal.fire(
                'Método de entrega',
                'Debe seleccionar un método de entrega!',
                'info'
            )
        }else{
            window.location.href = '/pagar'
            subir();
        }
    }

    const current = new Date();
    const date = `${current.getDate()}${current.getMonth()+1}${current.getFullYear()}`;

    const getRandomInt=(max)=> {
        return Math.floor(Math.random() * max);
    }

    const numOrden = `SHB${date}${getRandomInt(9)}${getRandomInt(9)}${getRandomInt(9)}${getRandomInt(9)}`

    const subir=()=>{
        let ob={
            ordenId: `${numOrden}`,
            typeEntrega: tipoEntrega,
            pago: entregaPago
        }
        localStorage.setItem('Orden', JSON.stringify(ob))
    }

    const pagoentrega=(num,tipo)=>{
        setEntregaPago(num)
        setTipoEntrega(tipo)
    }

    useEffect(()=>{
        const storeDireccion = JSON.parse(localStorage.getItem('Direccion'));
        if(storeDireccion){
            setDireccion(storeDireccion);
        }
      }
    ,[])

    // let mensaje = {
    //     "Nombre": `${direccion.Nombre}`,
    //     "Direccion": `${direccion.Ciudad} ${direccion.Sector} ${direccion.Calle}`,
    //     "Telefono": `${direccion.Telefono}`
    // }
    let mensaje = 'holaaa'

    return (
        <>
            
            <Header/>

            <div className="container-progress-checkout">
                <ProgressCheckout estilo={p1}/>
            </div>

            <div className='container-form-direction'>

                <div className='container-verificacion'>

                    <section className='facturacion'>
                        <h3>Facturación & Envío:</h3>
                        
                        <article>
                            <img src={require('../assets/images/usuario.png')} alt="" />
                            <h5>
                                {direccion.Nombre} <br />
                                {direccion.Telefono}
                            </h5>
                        </article>

                        <p>{`${direccion.Ciudad} ${direccion.Sector} ${direccion.Calle}`}</p>
                        <h4>
                            Referencia: <br />
                            {direccion.Referencia}
                        </h4>
                    </section>

                    <h2>Elegir un método de entrega</h2>

                    <section className="metodo-entrega">

                        <ul>

                            <li>
                                <input type="radio" name='entrega' id="domicilio" value='Envio a domicilio' onClick={(e)=> pagoentrega(250,e.target.value)}/>
                                <label for="domicilio">Envio a domicilio</label>
                                <span className='badge badge-secondary'>RD$ 250.00</span>
                            </li>

                            <li>
                                <input type="radio" name='entrega' id='vimenpaq' value='Envio a Vimenpaq' onClick={(e)=> pagoentrega(180,e.target.value)}/>
                                <label for="vimenpaq">Envio a Vimenpaq</label>
                                <span className='badge badge-secondary'>RD$ 180.00</span>
                                <p>Le enviaremos el paquete a su sucursal de vimenpaq mas cercana. En este link puede ver las sucursales de vimenpaq asi encontrar la que esta mas cerca de usted. <br />
                                    https://www.vimenpaq.do/oficinas/sucursales/
                                </p>
                            </li>

                            <li>
                                <input type="radio" name='entrega' id='caribetours' value='Envio a Caribetours' onClick={(e)=> pagoentrega(150,e.target.value)}/>
                                <label for='caribetours'>Envio a Caribetours</label>
                                <span className='badge badge-secondary'>RD$ 150.00</span>
                                <p>Le enviaremos el paquete a su sucursal de caribetours mas cercana. En este link puede ver las sucursales de caribetours asi encontrar la que esta mas cerca de usted. <br />
                                    https://caribetours.com.do/sucursales/
                                </p>
                            </li>

                        </ul>

                    </section>

                    <h2>Método de pago</h2>

                    <section className='metodo-pago'>
                        <h4>Transferencia bancaria</h4>
                    </section>

                    <section className='siguiente-atras'>

                        <div className="atras" onClick={()=> redireccionarAtras()}>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                >
                                <path
                                    d="M16.2426 6.34317L14.8284 4.92896L7.75739 12L14.8285 19.0711L16.2427 17.6569L10.5858 12L16.2426 6.34317Z"
                                    fill="currentColor"
                            />
                            </svg>
                            <h4>Atras</h4>
                        </div>
                        
                        <div className="siguiente" onClick={()=>redireccionarSiguiente()}>
                            <h4>Pagar ahora</h4>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.5858 6.34317L12 4.92896L19.0711 12L12 19.0711L10.5858 17.6569L16.2427 12L10.5858 6.34317Z" fill="currentColor" /></svg>
                        </div>
                        {/* <ReactWhatsapp className="siguiente" number="1-849-785-0712" message={mensaje}>
                            <h4>Siguiente</h4>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.5858 6.34317L12 4.92896L19.0711 12L12 19.0711L10.5858 17.6569L16.2427 12L10.5858 6.34317Z" fill="currentColor" /></svg>
                        </ReactWhatsapp> */}

                    </section>

                </div>

                <TableCheckout Entrega={entregaPago}/>
                
            </div>

            <Footer/>
        </>
    )
}

export default VerificacionCheckout
